"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";

const seededUnit = (seed: number) => {
  let t = seed + 0x6d2b79f5;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export default function EventNotFound() {
  const stars = Array.from({ length: 50 }, (_, i) => ({
    top: `${seededUnit(i * 2 + 1) * 100}%`,
    left: `${seededUnit(i * 2 + 2) * 100}%`,
  }));

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-purple-800 to-purple-600 text-white relative overflow-hidden px-4">
      
      {/* Animated stars background */}
      <div className="absolute inset-0">
        {stars.map((star, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-pulse"
            style={{ top: star.top, left: star.left }}
          />
        ))}
      </div>

      {/* Error Title */}
      <h1 className="text-7xl sm:text-8xl md:text-9xl font-extrabold mb-6 animate-bounce relative z-10">
        404
      </h1>

      {/* Message */}
      <p className="text-lg sm:text-xl md:text-2xl mb-8 max-w-lg text-center relative z-10">
        Oops! The event you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>

      {/* Calendar Icon */}
      <Calendar className="w-12 h-12 animate-bounce mb-6 relative z-10" />

      {/* Button to go back to events */}
      <Button
        className="bg-white text-purple-800 font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-gray-100 transition transform hover:-translate-y-1"
        onClick={() => (window.location.href = "/events")}
      >
        Go Back to Events
      </Button>

      {/* Pulse animation dots */}
      <div className="mt-12 flex gap-4 relative z-10">
        <div className="w-4 h-4 rounded-full bg-white animate-pulse"></div>
        <div className="w-4 h-4 rounded-full bg-white animate-pulse delay-200"></div>
        <div className="w-4 h-4 rounded-full bg-white animate-pulse delay-400"></div>
      </div>
    </div>
  );
}

